module.exports = __webpack_public_path__ + "static/media/header.307ca7de.mp3";